module.exports = __webpack_public_path__ + "static/media/BG.a6f7972c.jpg";